export default "__VITE_ASSET__BSwzfQDg__"